import React from 'react';

import { TextFieldValueRenderer } from '@/components/molecules/TextFieldValueRenderer';
import { TextField, ValueType } from '@/types/fields';

interface Props {
  readonly value: ValueType;
  readonly field: TextField<unknown>;
}
export const EmailFieldValueRenderer: React.FC<Props> = (props: Props): React.ReactElement => {
  const { value, field } = props;
  return <TextFieldValueRenderer value={value} field={field} />;
};
